import React, { useCallback, useEffect, useState } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { Input, version2 } from 'ui-components/components/input';
import { noop } from 'ui-components/default-props/noop';
import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import { useYupFormValidation } from '../../../../../validation/use-yup-form-validation';

import { messages } from '../../../../messages';
import { FORM_REQUIREMENTS } from '../../../../utilities/constants';
import { useWalletRegistrationFormContext } from '../../contexts/wallet-registration-form-context';
import { useWalletRegistrationErrorContext } from '../../contexts/wallet-registration-error-context';
import { NicknameSchema } from './schema';
import style from './style.module.less';

const MAX_NICKNAME_LENGTH = 50;

/**
 * @param {object} props
 * @param {(requirement: string, isValid: boolean) => void} props.markFormComplete
 * @returns {JSX.Element}
 */
export const WalletNickname = ({ markFormComplete = noop }) => {
  const intl = useIntl();
  const { showAllErrors } = useWalletRegistrationErrorContext();
  const { walletForm, updateWalletForm, submittingRegistration } = useWalletRegistrationFormContext();
  const [touched, setTouched] = useState(false);

  const { errors, isValid } = useYupFormValidation({
    form: walletForm,
    schema: NicknameSchema,
  });

  const onBlur = useCallback(() => {
    setTouched(true);
  }, [setTouched]);

  useEffect(() => {
    markFormComplete(FORM_REQUIREMENTS.NICKNAME, isValid);
  }, [markFormComplete, isValid]);

  const onChange = useCallback(
    (e) => {
      updateWalletForm([FORM_REQUIREMENTS.NICKNAME], e.target.value);
    },
    [updateWalletForm],
  );

  const shouldShowErrors = touched || showAllErrors;
  const inlineMessage = shouldShowErrors && errors?.[FORM_REQUIREMENTS.NICKNAME]?.message;
  const inlineMessageType = inlineMessage ? INLINE_MESSAGE_TYPES.error : undefined;

  return (
    <div className={style.nickname}>
      <Input
        className={style['nickname-input']}
        disabled={submittingRegistration}
        id='wallet-nickname'
        inlineMessage={inlineMessage}
        inlineMessageType={inlineMessageType}
        label={intl.formatMessage(messages.accountNickName)}
        maxLength={MAX_NICKNAME_LENGTH}
        name='nickname'
        onBlur={onBlur}
        onChange={onChange}
        type='text'
        value={walletForm?.[FORM_REQUIREMENTS.NICKNAME] || ''}
        version={version2}
      />
      <div className={style.subtext}>
        <FormattedMessage {...messages.accountNicknameSubtext} />
      </div>
    </div>
  );
};
